import { useTranslation } from 'react-i18next';
import { PageTitle } from '@/components';
import { I18nNamespace } from '@/lib/i18n-namespaces';

export function AlertRulesHeader() {
    const { t } = useTranslation(I18nNamespace.ALERT_RULES);

    return (
        <div className="pt-4 pb-8">
            <PageTitle text={t('title')} description={t('description')} />
        </div>
    );
}
